var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDayIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M0 10.2314C0 4.7086 4.47715 0.231445 10 0.231445H40V40.2314H10C4.47715 40.2314 0 35.7543 0 30.2314V10.2314Z",
    fill: "#DFE5F6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 24.2314C22.2091 24.2314 24 22.4406 24 20.2314C24 18.0223 22.2091 16.2314 20 16.2314C17.7909 16.2314 16 18.0223 16 20.2314C16 22.4406 17.7909 24.2314 20 24.2314Z",
    stroke: "#ADB6CF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5 14.7314L27 13.2314M20 10.2314V12.2314V10.2314ZM20 28.2314V30.2314V28.2314ZM13 13.2314L14.5 14.7314L13 13.2314ZM25.5 25.7314L27 27.2314L25.5 25.7314ZM10 20.2314H12H10ZM28 20.2314H30H28ZM13 27.2314L14.5 25.7314L13 27.2314Z",
    stroke: "#ADB6CF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDayIcon);
export default __webpack_public_path__ + "static/media/dayIcon.897c0937382705509a51e3671dcd854d.svg";
export { ForwardRef as ReactComponent };